module.exports = window.sharedLibraries["nushop"]["react"];